import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'molecule-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit{
  @Input() footerText:string = '';

  constructor(){}

  ngOnInit(){
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    this.footerText = `© 2016-${currentYear} Bit-iot`;
  }
}
